<script setup>
import { computed } from "vue";
import ArgonCalendar from "@/components/ArgonCalendar.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonRadio from "@/components/ArgonRadio.vue";

const props = defineProps({
  date: {
    type: String,
    default: "",
  },
  todayQueryDate: {
    type: String,
    default: "",
  },
  dateError: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "RECOGIDA",
  },
});

const emit = defineEmits(["update:date", "update:type", "next"]);

const dateModel = computed({
  get() {
    return props.date;
  },
  set(value) {
    emit("update:date", value);
  },
});

const typeModel = computed({
  get() {
    return props.type;
  },
  set(value) {
    emit("update:type", value);
  },
});
</script>

<template>
  <div
    class="multisteps-form__panel js-active p-2 position-relative bg-white rounded-3"
    data-animation="FadeIn"
  >
    <div class="d-flex flex-column" style="min-height: 300px;">
      <div class="text-center mb-3">
        <p class="mb-0">Selecciona la fecha del nuevo plan</p>
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-md-2 col-lg-3">
          <argon-calendar
            id="plan-date"
            v-model="dateModel"
            :min="todayQueryDate"
            :error="dateError"
          />
        </div>
      </div>

      <div class="text-center mt-4 mb-2">
        <p class="mb-0">Selecciona el tipo de plan</p>
      </div>

      <div class="d-flex justify-content-center gap-4 text-center">
        <div class="d-inline-flex align-items-center gap-2 mb-0">
          <span>Recogida</span>
          <argon-radio
            id="plan-type-recogida"
            v-model="typeModel"
            name="RECOGIDA"
            group-name="plan-type"
          />
        </div>

        <div class="d-inline-flex align-items-center gap-2 mb-0">
          <span>Entrega</span>
          <argon-radio
            id="plan-type-entrega"
            v-model="typeModel"
            name="ENTREGA"
            group-name="plan-type"
          />
        </div>

        <div class="d-inline-flex align-items-center gap-2 mb-0">
          <span>Ambos</span>
          <argon-radio
            id="plan-type-ambos"
            v-model="typeModel"
            name="AMBOS"
            group-name="plan-type"
          />
        </div>
      </div>

      <div class="mt-auto text-end">
        <argon-button
          class="mb-0 ms-auto btn-icon-only"
          color="primary"
          variant="outline"
          size="xs"
          aria-label="Siguiente"
          @click.prevent="emit('next')"
        >
          <span class="btn-inner--icon">
            <i class="fas fa-chevron-right" aria-hidden="true"></i>
          </span>
        </argon-button>
      </div>
    </div>
  </div>
</template>

 
